import lifecycle from "page-lifecycle";

let panels = [];
let fragments = {};
let loginId = "";
let communicationId = 0;
const commentMap = {};

function checkTerminal()
{
	if (lifecycle.state !== "active" && lifecycle.state !== "passive") return;	// browser window is hidden

	//$.getJSON("check_terminal?"+getTextBoxParams(),function(callInfoArrayObject){
	$.ajax({
		type: "POST",
		url: "check_terminal?uniq_param="+(new Date()).getTime()+getTextBoxParams(),
		contentType: "application/json; charset=UTF-8",
		dataType: "json",
		success: function(callInfoArrayObject){
			// jsonObject[0].author, for example.
			//alert("JSON Received Data: " + json);
			//var callInfo = $.parseJSON('{"uid":"85789756","call_address":"737924718","call_start":"11:37","call_duration":"00:00:00","call_state":4,"customer":0,"person":0,"branch":0,"communication":2001317,"comment":"","editedBy":"admin","direction":"INCOMING"}');

			if(callInfoArrayObject.length===0)
			{
				//hide all viewed panels
				$("#cti_terminal").html("");
				panels = [];
				fragments = {};
			}
			else
			{
				//console.log(panels);
				$.each(callInfoArrayObject, function(i,callInfoObject)
				{
					let panelExist = false;
					if(panels.length>0)
					{
						$.each(panels, function(ii,oldCallInfoObject)
						{
							if(callInfoObject.uid===oldCallInfoObject.uid)
							{
								panelExist = true;
								compareInfos(oldCallInfoObject, callInfoObject);
							}
						});
					}
					if(!panelExist)
					{
						panels.push(callInfoObject);
						$("#cti_terminal").html($("#cti_terminal").html()+generatePanel(callInfoObject));
						//init mouseevent
						initCloseImg();
					}
				});
				
				//hide removed infoPanel
				if(panels.length>callInfoArrayObject.length)
				{
					$.each(panels, function(i,oldCallInfoObject)
					{
						let panelDelete = true;
						$.each(callInfoArrayObject, function(ii,callInfoObject)
						{ 
							if(callInfoObject.uid===oldCallInfoObject.uid) panelDelete = false;
						});
						if(panelDelete) $('#callInfoTable_'+oldCallInfoObject.uid).hide();
					});
				}
			}
		},
		error: function (request, status, error){
			console.log(request.responseText+' - error:'+error.message);
		}
	});
}

export function startCheck()
{
	setInterval(checkTerminal, 2000);
}


function generatePanel(callInfoObject)
{
	//console.log("communication: "+callInfoObject.communication);
	const uid = callInfoObject.uid;
	let panel = '<div id="callInfoDiv_' + uid + '">';
	panel += '<table id="callInfoTable_'+uid+'" class="callInfoTable" style="background-color: '+getBackgroundColor(callInfoObject)+';"><tbody>';
	panel += '<div id="closeInfoTable_'+uid+'" style="position: absolute;left: 199px;line-height: 0;"><a href="javascript:void(0);" onclick="closeInfoTable(\''+uid+'\');"><span class="fi" style="display:none" id="closeInfoTableImg_'+uid+'">'+Icon.entity("close")+'</span></a></div>';
	panel += '<tr class="callInfoTableHeader_'+uid+'" style="line-height: 18px;background-color: '+getBackgroundHeaderColor(callInfoObject)+';">';
	panel += '<td style="padding: 3px 4px;">';
	if(callInfoObject.communication>0) panel += '<a href="editContact.do?id='+callInfoObject.communication+'">';
	panel += '<span class="fi" id="callInfoIcon_'+uid+'">'+Icon.entity(getIcon(callInfoObject.direction))+'</span>';
	if(callInfoObject.communication>0) panel += '</a>';

	if(callInfoObject.customer>0)
	{
		panel += '&nbsp;<a href="editCustomer.do?id='+callInfoObject.customer+'">'+callInfoObject.customerTitle+'</a></td></tr>';
	}
	if(callInfoObject.person>0)
	{
		panel += '<tr class="callInfoTableHeader_'+uid+'" style="line-height: 14px;background-color: '+getBackgroundHeaderColor(callInfoObject)+';"><td style="padding-left:24px;padding-bottom: 3px;"><a href="editPerson.do?id='+callInfoObject.person+'">'+callInfoObject.personTitle+'</a></td></tr>';
	}
	if(callInfoObject.branch>0)
	{
		panel += '<tr class="callInfoTableHeader_'+uid+'" style="line-height: 14px;background-color: '+getBackgroundHeaderColor(callInfoObject)+';"><td style="padding-left:24px;padding-bottom: 3px;"><a href="editBranch.do?id='+callInfoObject.branch+'">'+callInfoObject.branchTitle+'</a></td></tr>';
	}
	if(callInfoObject.customer===0 && callInfoObject.person===0 && callInfoObject.branch===0)
	{
		if(callInfoObject.communication>0)
		{
			panel = panel+'&nbsp;<a href="convertObject.do?destType=7&srcType=6&srcId='+callInfoObject.communication+'&connect=true">??? '+callInfoObject.call_address+'</a>';
		}
		else
		{
			panel = panel+'&nbsp;<a href="createParty.do?telWork='+callInfoObject.call_address+'">??? '+callInfoObject.call_address+'</a>';
		}
		panel += '</td></tr>';
	}
	panel += '<tr style="line-height: 18px;">';
	panel += '<td><span><span class="fi">'+Icon.entity('clock')+'</span><span>'+callInfoObject.call_start+'</span></span>&nbsp;&nbsp;&nbsp;&nbsp;<span id="callInfoTableStopwatch_'+uid+'" style="display:'+getDisplayStyleStopwatch(callInfoObject)+';"><span class="fi" style="margin-left:10px">'+Icon.fi("stopwatch")+'</span><span id="callInfoDuration_'+uid+'">'+callInfoObject.call_durationTime+'</span></span></td>';
	panel += '</tr>';
	if(callInfoObject.htmlFragment)
	{
		panel += '<tr><td colspan="2">'+callInfoObject.htmlFragment+'</td><tr>';
	}
	panel += '<tr id="callInfoTableBox_'+uid+'" style="display:'+getDisplayStyleBox(callInfoObject)+';">';
	panel += '<td><textarea id="comment_'+uid+'" name="comment_'+uid+'" style="height:42px;">'+callInfoObject.comment+'</textarea></td>';
	panel += '</tr>';
	panel += '</tbody></table><div>';

	return panel;
}

function updatePanelItem(itemID, itemValue)
{
	$("#"+itemID).text(itemValue);
}

function compareInfos(oldInfo, newInfo)
{
	if(oldInfo.call_state!==newInfo.call_state)
	{
		$("#callInfoTable_"+newInfo.uid).css("background-color",getBackgroundColor(newInfo));
		$(".callInfoTableHeader_"+newInfo.uid).css("background-color",getBackgroundHeaderColor(newInfo));
	}
	if($("#callInfoDuration_"+oldInfo.uid).text() !== newInfo.call_durationTime) updatePanelItem("callInfoDuration_"+newInfo.uid, newInfo.call_durationTime);
	
	if(newInfo.call_duration > 0)
	{
		$("#callInfoTableStopwatch_"+newInfo.uid).show();
		if(parseInt(communicationId) !== parseInt(newInfo.communication)) $("#callInfoTableBox_"+newInfo.uid).show();
	}
	
	//refresh comment box - disabled
	//if(newInfo.editedBy === loginId) updatePanelItem("comment_"+newInfo.uid, newInfo.comment);
	//else hideCommentByUID(newInfo.uid,newInfo.editedBy);
	if(newInfo.editedBy !== loginId) hideCommentByUID(newInfo.uid,newInfo.editedBy);
}

//init first view
function getDisplayStyleBox(callInfo)
{
	if(parseInt(communicationId) === parseInt(callInfo.communication)) return "none";
	if(callInfo.call_duration > 0) return "inherite";
	else return "none";
}

function getDisplayStyleStopwatch(callInfo)
{
	if(callInfo.call_duration >"00:00") return "inherite";
	else return "none";
}

export function showPanelsAfterReady(callInfoArrayObject, userId)
{
	//init
	$('form').each(function()
	{
		if($(this).attr('id') === "contactForm")
		{
			communicationId = $("#id").val();
			//console.log("communicationId: "+communicationId);
		}
		else communicationId = 0;
	});
	
	loginId = userId;
	$.each(callInfoArrayObject, function(i,callInfoObject)
	{
		let panelExist = false;
		$.each(panels, function(ii,oldCallInfoObject)
		{
			if(callInfoObject.uid===oldCallInfoObject.uid)
			{
				panelExist = true;
				$("#cti_terminal").html($("#cti_terminal").html()+generatePanel(oldCallInfoObject));
			}
		});
		if(!panelExist)
		{
			panels[i] = callInfoObject;
			$("#cti_terminal").html($("#cti_terminal").html()+generatePanel(callInfoObject));
		}
		if(callInfoObject.call_duration > 0) $("#callInfoTableStopwatch_"+callInfoObject.uid).show();
		hideCommentByUID(callInfoObject.uid, callInfoObject.editedBy);
	});
	initCloseImg();
}

function initCloseImg()
{
	$(".callInfoTable").each(function(index)
	{
		const array = $(this).attr("id").split("_");
		const id = array[1];
		$('#callInfoDiv_'+id).hover(function()
		{
			const divTop = $('#cti_terminal').offset();
			const positionXY = $('#callInfoTable_' + id).offset();
			const scrollWindow = $(window).scrollTop();
			if(divTop.top - scrollWindow > 10) $('#closeInfoTable_'+id).css("top",positionXY.top-5).css("left", 199); //no scroll position
			else $('#closeInfoTable_'+id).css("top",positionXY.top - scrollWindow-16).css("left", 191); //scrolling position
			$('#closeInfoTableImg_'+id).show();
		},function()
		{
			$('#closeInfoTableImg_'+id).hide();
		});
		
		//console.log('before keypress event '+id);
		$("#comment_"+id).keypress(function (e) {
			if(e.which === 13 && !e.shiftKey) {        
				closeInfoTable(id);
				e.preventDefault();
			}
		});
	});
}

function getBackgroundColor(callInfo)
{
	let color;
	switch(callInfo.call_state)
	{
		case 1: case 5:color='#FFCC99';break;
		case 2:color='#99FF99';break;
		case 3:color='#99FF99';break;
		case 6:color='#CCCCCC';break;
		case 4: 
		default: if(callInfo.call_duration > 0) color='#99CCFF';
				 else color='#CCCCCC';break;
	}
	return color;
}

function getBackgroundHeaderColor(callInfo)
{
	let color;
	switch(callInfo.call_state)
	{
		case 1: case 5:color='#FFB973';break;
		case 2:color='#73FF73';break;
		case 3:color='#73FF73';break;
		case 6:color='#B8B8B8';break;
		case 4: 
		default: if(callInfo.call_duration > 0) color='#73B9FF';
				 else color='#B8B8B8';break;
	}
	return color;
}

function getIcon(direction)
{
	if(direction==="INCOMING") return 'call-in';
	else if(direction==="OUTGOING") return 'call-out';
	else return 'phone';
}

function getTextBoxParams()
{
	let retValue = "";
	$.each(panels, function(i,oldCallInfoObject)
	{
		if(oldCallInfoObject!==null)
		{
			if(parseInt(oldCallInfoObject.communication)!==parseInt(communicationId))
			{
				const commentBox = $("#comment_" + oldCallInfoObject.uid).val();
				if(commentBox!==null && commentBox.length>0)
				{
					const oldComment = commentMap[oldCallInfoObject.uid];
					if(commentBox!==oldComment)
					{
						if(retValue.length>0) retValue = retValue + "&";
						retValue = retValue+"comment_"+oldCallInfoObject.uid+"="+encodeURIComponent(commentBox);
						commentMap[oldCallInfoObject.uid] = commentBox;
					}
				}
			}
		}
	});
	if(retValue.length>0) retValue = "&" +retValue;
	return retValue;
}

function hideCommentByUID(itemUID,userId)
{
	if(userId!==null && userId!==0 && loginId!==userId)
	{
		$("#comment_"+itemUID).text("").hide();
	}
	else $("#comment_"+itemUID).show();
}

window.closeInfoTable = closeInfoTable;
function closeInfoTable(itemUID)
{
	const commentBox = $("#comment_" + itemUID).val();
	//remove callInfoObject from panels and HTML dom
	let toRemove = null;
	$.each(panels, function(i,callInfoObject)
	{
		if(parseInt(callInfoObject.uid)===parseInt(itemUID)) toRemove = callInfoObject;
	});
	if(toRemove!==null)
	{
		panels = $.grep(panels, function(value) {
			return value !== toRemove;
		});
	}
	$('#callInfoDiv_'+itemUID).remove();
	//
	
	
	$.ajax({
		type: "POST",
		url: "check_terminal?closeId="+itemUID+"&sourceCommunication="+communicationId+"&comment_"+itemUID+"="+commentBox,
		contentType: "application/json; charset=UTF-8",
		success: function(){
			
		},
		error: function (request, status, error){
			console.log(request.responseText+' - error:'+error.message);
		}
	});
}
